module.exports = __webpack_public_path__ + "73b68a188bdb8ae8d9f857ef2eef0a12.svg";